import { render } from "./ResponseWarning.vue?vue&type=template&id=641a9574"
import script from "./ResponseWarning.vue?vue&type=script&lang=js"
export * from "./ResponseWarning.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__